<!--
  钱包详情
-->
<template>
  <div class='wallet-detail-content'>
    <title-header title='资产明细'></title-header>
    <van-tabs v-model="active" @change=changeTab() color="#45C5DA">
      <van-tab title="全部" name='0'></van-tab>
      <van-tab title="收入" name='1'></van-tab>
      <van-tab title="提现" name='2'></van-tab>
    </van-tabs>
    <div class='detail-list'>
      <div class='detail-item' v-for='(item, index) in detailList' :key='index'>
        <div class='detail-info'>
          <span>{{item.type | getOperationType}}</span>
          <span :class='{"add-beans": (item.type == 1 || item.type == 3), "delete-beans": ((item.type == 2 || item.type == 4))}'>{{item.points | getBeansChange(item.type)}}</span>
        </div>
        <div class='create-time'>{{item.createAt}}</div>
      </div>
    </div>
    <van-pagination 
      style='margin-top:10px;'
      force-ellipses
      v-model="page.pageNumber" 
      :total-items="page.total" 
      :items-per-page="page.pageSize"
      @change='changePage'
    />
    <van-loading class="data-loading" color="#45C5DA" v-show="showLoading" />
  </div>
</template>

<script>
  import api from 'api/wallet';
  export default {
    data() {
      return {
        active: 0,
        detailList: [],
        showLoading: true,
        page: {
          pageSize: 5,
          pageNumber: 1
        }
      }
    },
    created() {
      this.getAssetBreakdown()
    },
    methods: {
      //切换标签
      changeTab(val) {
        this.page.pageNumber = 1;
        this.getAssetBreakdown()
      },
      //获取资产明细
      async getAssetBreakdown() {
        this.showLoading = true;
        const data = await api.getAssetBreakdown({
          //查询全部不用传参数
          pageSize: this.page.pageSize,
          pageNum: this.page.pageNumber,
          inFlag: this.active == 0 ? null: this.active
        })
        this.showLoading = false;
        this.detailList = data.records;
        this.page.total = data.total;
      },
      changePage() {
        this.getAssetBreakdown()
      }
    },
    filters: {
      //操作类型
      getOperationType(val) {
        switch (val) {
          case 1:
            return '分销收入'
          case 2:
            return '提现'
          case 3:
            return '提现被拒绝，金豆退回'
          case 4:
            return '退款，佣金扣除'
        }
        return ''
      },
      //数量变化
      getBeansChange(num, type) {
        switch (type) {
          case 1:
            return `+${num}豆`
          case 2:
            return `-${num}豆`
          case 3:
            return `+${num}豆`
          case 4:
            return `-${num}豆`
        }
        return ''
      }
    }
  }
</script>
<style lang='scss'>
  @import 'common/sass/theme.scss';
  .wallet-detail-content .van-pagination__item{
    color: $theme-color;
  }
  .wallet-detail-content .van-pagination__item--active{
    background-color: $theme-color;
    color: #fff;
  }
</style>
<style lang='scss' scoped>
  @import 'common/sass/theme.scss';
  .detail-list{
    padding: 15px;
  }
  .detail-item{
    border-bottom: 1px solid $light-color;
    .detail-info{
      display: flex;
      justify-content: space-between;
      .add-beans{
        color: #19be6b;
      }
      .delete-beans{
        color: #ee0a24; 
      }
    }
    .create-time{
      margin: 5px 0;
      color: $lingt-word-color;
      font-size: 13px;
    }
  }
</style>